module.exports = __webpack_public_path__ + "static/media/AdvancePayment.b6c002f6.png";